import { createDefaultTyrann } from '@apis/common';
import { prefAndCityByZipcode, provAndCityByZipcodeResponse } from '@models/FC';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const postNewCargoCalculatorBody = t.type({
  service_id: t.number,
  target_pol_name: t.string,
  calc_type: t.number,
  target_type: t.number,
  city_cd: t.string,
  grade: t.string,
  list: t.array(
    t.union([
      t.type({
        m3: t.number,
        kg: t.number,
      }),
      t.type({
        num: t.number,
        l: t.number,
        w: t.number,
        h: t.number,
      }),
    ]),
  ),
});

export type PostNewCargoCalculatorBody = t.TypeOf<typeof postNewCargoCalculatorBody>;

export const cargoCalculatorTruckItem = t.type({
  truck_type: t.string,
  price: t.type({
    non_target_tax_price: t.number,
    target_tax_price: t.number,
    shipping_tax: t.number,
  }),
  lead_time: t.type({
    total_lead_time: t.union([t.string, t.number]),
    truck_lead_time: t.union([t.string, t.number]),
  }),
});

export type CargoCalculatorTruckItem = t.TypeOf<typeof cargoCalculatorTruckItem>;

export const cargoCalculatorItem = t.type({
  base: t.string,
  target_kg: t.number,
  on_sea_measure: t.number,
  pol: t.string,
  pod: t.string,
  list: t.array(cargoCalculatorTruckItem),
});

export type CargoCalulatorItem = t.TypeOf<typeof cargoCalculatorItem>;

export const newCargoCalculatorResponse = t.type({
  code: t.string,
  message: t.string,
  count: t.number,
  last_used: t.string,
  data: cargoCalculatorItem,
});

export type NewCargoCalculatorResponse = t.TypeOf<typeof newCargoCalculatorResponse>;

export const fcApis = createDefaultTyrann({
  '/fc/pol/': {
    get: {
      query: t.type({
        service_id: t.number,
      }),
      response: {
        200: t.type({
          pol: t.array(
            t.type({
              name: t.string,
              code: t.string,
            }),
          ),
          code: t.string,
        }),
      },
    },
  },
  '/fc/pref-and-city': {
    get: {
      response: {
        200: t.type({
          pref: t.array(
            t.type({
              pref: t.string,
              pref_rome: t.string,
            }),
          ),
        }),
      },
    },
  },
  '/fc/pref-and-city?pref={pref}': {
    get: {
      path: t.type({
        pref: t.string,
      }),
      response: {
        200: t.type({
          city: t.array(
            t.type({
              city_cd: t.string,
              city: t.string,
            }),
          ),
        }),
      },
    },
  },
  '/fc/pref-and-city-by-zipcode/': {
    get: {
      query: t.type({
        zipcode: t.string,
      }),
      response: {
        200: prefAndCityByZipcode,
        400: t.type({}),
        404: t.type({
          code: t.string,
          message: t.string,
        }),
      },
    },
  },
  '/fc/cargo-calculator/': {
    get: {
      response: {
        200: t.type({
          count: t.number,
          last_used: t.string,
        }),
      },
    },
    post: {
      body: postNewCargoCalculatorBody,
      response: {
        200: newCargoCalculatorResponse,
        400: t.type({
          message: h.omittable(t.string),
          non_field_errors: h.omittable(t.array(t.string)),
        }),
        403: t.type({
          code: t.string,
          message: t.string,
          count: h.omittable(t.number),
          last_used: h.omittable(t.string),
        }),
        404: t.type({
          code: t.string,
          message: t.string,
        }),
      },
    },
  },
  '/fc/prov-and-city-by-zipcode/': {
    get: {
      query: t.type({
        zipcode: t.string,
      }),
      response: {
        200: provAndCityByZipcodeResponse,
        400: t.type({}),
        404: t.type({
          code: t.string,
          message: t.string,
        }),
      },
    },
  },
  '/fc/cargo-calculator-v2/': {
    post: {
      body: postNewCargoCalculatorBody,
      response: {
        200: newCargoCalculatorResponse,
        400: t.type({
          message: h.omittable(t.string),
          non_field_errors: h.omittable(t.array(t.string)),
        }),
        403: t.type({
          code: t.string,
          message: t.string,
          count: h.omittable(t.number),
          last_used: h.omittable(t.string),
        }),
        404: t.type({
          code: t.string,
          message: t.string,
        }),
      },
    },
  },
});
